import img0 from '../Components/Images/Services/Services.png';
import img1 from '../Components/Images/Services/servicesHome1.png';
import img2 from '../Components/Images/Services/servicesHome2.png';
import img3 from '../Components/Images/Services/servicesHome3.png';

import img4 from '../Components/Images/Services/promiseIcon1.png';
import img5 from '../Components/Images/Services/promiseIcon2.png';
import img6 from '../Components/Images/Services/promiseIcon3.png';
import img7 from '../Components/Images/Services/promiseIcon4.png';

import img8 from '../Components/Images/Services/checklist.png';
import img9 from '../Components/Images/Services/checklistImg.jpg';

import img10 from '../Components/Images/Services/FAQs.png';

export const images=[
    {
        id:0,
        url:img0
    },
    {
        id:1,
        url:img1
    },
    {
        id:2,
        url:img2
    },
    {
        id:3,
        url:img3
    },
    {
        id:4,
        url:img4
    },
    {
        id:5,
        url:img5
    },
    {
        id:6,
        url:img6
    },
    {
        id:7,
        url:img7
    },
    {
        id:8,
        url:img8
    },
    {
        id:9,
        url:img9
    },
    {
        id:10,
        url:img10
    },
]